import { useEffect, useState } from "react";
import EmployeeChart from "./Charts/EmployeeChart";
import { Grid, useTheme } from "@mui/material";
import Counts from "./Counts";
import AttendancePieChart from "./Charts/AttendancePieChart";
import EmployeeTimeChart from "./Charts/TopWorkerChart";
import TopTimesheetChart from "./Charts/TopTimesheetChart";
import { loadDashboard } from "../../redux/actions/dashboard.actions";
import { useDispatch, useSelector } from "react-redux";
import { storeStateType } from "../../redux/store";

import Highcharts from "highcharts";

import darkUnica from "highcharts/themes/dark-unica"; // Import the dark theme

export default function DashboardNew() {
  const dispatch = useDispatch();
  const {
    counts,
    total_shift_count,
    monthly_employee_signup,
    top_employee,
    top_workers,
  } = useSelector((state: storeStateType) => state.dashboard);

  const { role } = useSelector((state: storeStateType) => state.auth);
  const [render, setRender] = useState(false);

  useEffect(() => {
    dispatch<any>(loadDashboard());
  }, [dispatch, role]);

  const theme = useTheme();

  useEffect(() => {
    if (theme.palette.mode === "dark") {
      darkUnica(Highcharts);
      setRender((preState) => !preState);
    } else {
      setRender((preState) => !preState);
    }
  }, [theme.palette.mode]);

  return (
    <Grid container rowGap={2} key={`${render}-container`}>
      <>
        <Counts counts={counts} />
        <Grid container spacing={1}>
          <>
            <Grid item xs={12} md={6}>
              {<TopTimesheetChart top_employee={top_employee} />}
            </Grid>
            <Grid item xs={12} md={6}>
              <EmployeeTimeChart top_workers={top_workers} />
            </Grid>
          </>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <EmployeeChart monthly_employee_signup={monthly_employee_signup} />
          </Grid>
          <Grid item xs={12} md={6}>
            <AttendancePieChart total_shift_count={total_shift_count} />
          </Grid>
        </Grid>
      </>
    </Grid>
  );
}
